<template>
  <div class="TabMenuCom">
    <p
      v-for="(v, i) in menuList"
      :key="i"
      @click="changeTab(v)"
      :style="{
        borderColor: $parent.activeName == v?.name ? '#28cccb' : 'transparent',
        color: $parent.activeName == v?.name ? '#28cccb' : '#666',
      }"
    >
      {{ v?.name }}
    </p>
  </div>
</template>

<script>
import api from "@/api";
export default {
  props: {
    activeItem: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      menuList: [],
    };
  },
  watch: {
    activeItem: {
      handler(newvalue, oldvalue) {
        this.getMenuList();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    async getMenuList() {
      if (this._.isEmpty(this.activeItem)) {
        return;
      }
      const type = this.activeItem?.type || this.activeItem?.deviceType;
      let res = await api.DMGetByName({
        name: type,
      });
      if (res && res.data.code == 200) {
        const newData = (res.data?.data || []).filter((item) =>
          [
            "参数",
            "工单记录",
            "报警记录",
            "时间设置",
            "预警设置",
            "定时关闭",
            "自动控制",
          ].includes(item?.name)
        );
        // console.log('----getMenuList----', res.data.data,newData)
        this.menuList = newData;
        this.$parent.activeName = newData?.[0]?.name || "";
        this.$parent.activeParamsOption = newData?.[0]?.child || [];
        this.$parent.activeIdWithParams = `${
          this.activeItem?.id?.id || this.activeItem?.deviceId
        }-${(newData?.[0]?.child || []).map((item) => item.name).toString()}`;
      } else {
        console.log("获取设备参数列表失败");
      }
    },
    changeTab(data) {
      this.$parent.activeName = data.name;
      this.$parent.activeParamsOption = data.child;
      this.$parent.activeIdWithParams = `${
        this.activeItem?.id?.id || this.activeItem?.deviceId
      }-${(data?.child || []).map((item) => item.name).toString()}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.TabMenuCom {
  width: 100%;
  height: 100%;
  @include setFlexStart;

  p {
    margin: 0 20px;
    color: #666;
    font-size: 18px;
    line-height: 40px;
    font-weight: 500;
    border-bottom: 2px solid transparent;
    cursor: pointer;
  }
}
</style>
